var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;opacity:0.1;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#000000;stroke-width:1.2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{opacity:0.1;fill:#A20C33;}\n\t.st5{fill:#A20C33;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,5L5.5,7.3C5.2,7.8,5,8.3,5,8.8V22c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V8.8c0-0.5-0.2-1.1-0.5-1.5L20.8,5 c-0.5-0.6-1.2-1-2-1H9.3C8.5,4,7.7,4.4,7.3,5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.2,3.1L3.8,5C3.3,5.6,3,6.4,3,7.3V20c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V7.3c0-0.8-0.3-1.6-0.8-2.3 l-1.4-1.9C18.3,2.4,17.5,2,16.7,2H7.3C6.5,2,5.7,2.4,5.2,3.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 3.4,
    y1: 6,
    x2: 20.4,
    y2: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M16,10c0,2.2-1.8,4-4,4s-4-1.8-4-4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M7.3,5L5.5,7.3C5.2,7.8,5,8.3,5,8.8V22c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V8.8c0-0.5-0.2-1.1-0.5-1.5L20.8,5 c-0.5-0.6-1.2-1-2-1H9.3C8.5,4,7.7,4.4,7.3,5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.7,4.6l-1.4-1.9c-0.6-0.8-1.6-1.3-2.6-1.3H7.3c-1,0-2,0.5-2.6,1.3v0L3.3,4.6C2.7,5.4,2.4,6.3,2.4,7.3V20 c0,1.4,1.2,2.6,2.6,2.6h14c1.4,0,2.6-1.2,2.6-2.6V7.3C21.6,6.3,21.3,5.4,20.7,4.6z M5.7,3.4c0.4-0.5,1-0.8,1.7-0.8h9.3 c0.7,0,1.3,0.3,1.7,0.8l1.4,1.9c0,0,0,0,0,0.1H4.2c0,0,0,0,0-0.1L5.7,3.4z M20.4,20c0,0.8-0.6,1.4-1.4,1.4H5 c-0.8,0-1.4-0.6-1.4-1.4V7.3c0-0.2,0-0.5,0.1-0.7h16.6c0,0.2,0.1,0.4,0.1,0.7V20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16,9.4c-0.3,0-0.6,0.3-0.6,0.6c0,1.9-1.5,3.4-3.4,3.4S8.6,11.9,8.6,10c0-0.3-0.3-0.6-0.6-0.6S7.4,9.7,7.4,10 c0,2.5,2.1,4.6,4.6,4.6c2.5,0,4.6-2.1,4.6-4.6C16.6,9.7,16.3,9.4,16,9.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersIcon);
export default __webpack_public_path__ + "static/media/offersIcon.9cd31566eaccc3e2d5ea8afddcab1256.svg";
export { ForwardRef as ReactComponent };